/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(function() {
	'use strict';

	/**
	* @param {number} value - input number for the property
	* @param {Boolean} true iff the value is a float number or null
	*/
	const validateNumIsFloatOrNull = value => !(isNaN(value) || isNaN(Number.parseFloat(value))) || (value === null);

	return {
		SHORT_EFFECT_DURATION: 100,// CADBC-990 (Formerly 350),
		LONG_EFFECT_DURATION:  100,    // CADBC-990 (Formerly 500),

		validateNumIsFloatOrNull: validateNumIsFloatOrNull,

		minMaxValidationOptions: {
			checkForValidValue: validateNumIsFloatOrNull,
			supportsValidationChecks: true,
			validationInfo: {
				supportsFloats: true,
				messageId: 'customRangeErrorMessage'
			}
		}
	};
});